import React, { useContext } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import AccordionDetails from '@mui/material/AccordionDetails'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import JourneyMiniCard from './JourneyMiniCard'
import { PTSControlContext } from '../PTSControl'

const RouteAccordion = ({ route, routeIndex, isSelected, onSelect }) => {
  const journeyCount = route?.journeys?.length ?? 0
  const openCount = (route?.journeys ?? []).filter(
    (j) =>
      !['Completed', 'Cancelled', 'No Show', 'Aborted'].includes(j?.status),
  ).length

  return (
    <Accordion
      disableGutters
      expanded={isSelected}
      onChange={(_, expanded) => {
        onSelect?.(expanded)
      }}
      sx={{
        background: isSelected
          ? 'rgba(35,154,164,0.10)'
          : 'rgba(255,255,255,0.03)',
        border: isSelected
          ? '1px solid rgba(35,154,164,0.35)'
          : '1px solid rgba(255,255,255,0.06)',
        boxShadow: 'none',
        borderRadius: '12px !important',
        overflow: 'hidden',
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ArrowDropDown sx={{ color: '#E2E8F0' }} />}
        sx={{
          minHeight: 'unset',
          px: 1.25,
          py: 1,
          '&.Mui-expanded': {
            minHeight: 'unset',
          },
          '& .MuiAccordionSummary-content': {
            margin: 0,
          },
          '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: 0,
          },
        }}
      >
        <Stack width="100%" spacing={0.75}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
          >
            <Typography
              sx={{
                color: '#F8FAFC',
                fontWeight: 700,
                fontSize: '0.92rem',
              }}
            >
              Route {routeIndex + 1}
            </Typography>

            <Stack direction="row" spacing={0.5}>
              <Chip
                label={`${journeyCount} ${journeyCount === 1 ? 'journey' : 'journeys'}`}
                size="small"
                sx={{
                  height: 22,
                  color: '#E2E8F0',
                  backgroundColor: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  fontWeight: 700,
                  borderRadius: 1.5,
                }}
              />
              <Chip
                label={route?.isComplete ? 'Complete' : `${openCount} open`}
                size="small"
                sx={{
                  height: 22,
                  color: route?.isComplete ? '#86EFAC' : '#FCD34D',
                  backgroundColor: route?.isComplete
                    ? 'rgba(34,197,94,0.14)'
                    : 'rgba(245,158,11,0.14)',
                  border: route?.isComplete
                    ? '1px solid rgba(134,239,172,0.24)'
                    : '1px solid rgba(252,211,77,0.24)',
                  fontWeight: 700,
                  borderRadius: 1.5,
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          pt: 0,
          px: 1,
          pb: 1,
        }}
      >
        <Box
          sx={{
            pr: 0.5,
            mt: 1,
          }}
        >
          <Stack spacing={1}>
            {(route?.journeys ?? []).map((journey, journeyIndex) => (
              <React.Fragment key={journey?._id || journeyIndex}>
                <JourneyMiniCard
                  journey={journey}
                  routeIndex={routeIndex}
                  journeyIndex={journeyIndex}
                />
                {journeyIndex < route.journeys.length - 1 && (
                  <Divider sx={{ borderColor: 'rgba(255,255,255,0.05)' }} />
                )}
              </React.Fragment>
            ))}
          </Stack>
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default RouteAccordion
